import { FC, useState } from 'react'
import Image from 'next/image'

import CommentInputBlock from '../../comment-input-block/comment-input-block'

import { STATIC_URL } from '../../../../../constants/data'
import { resizeTexarea } from '../../utils'

import styles from './comment-send.module.scss'

interface ICommentSend {
  id: number | string
  handleSendAnswer?: (
    id?: number | string,
    inputText?: string,
    parentCommentId?: number | string
  ) => void
  parentCommentId: number | string
}

const imgPath = `${STATIC_URL}/comment/icon_comment_black.svg`

const CommentSend: FC<ICommentSend> = ({ id, handleSendAnswer, parentCommentId }: ICommentSend) => {
  const [inputText, setInputText] = useState('')
  const [isShowAnswerArea, setShowAnswerArea] = useState(false)

  const sendAnswer = () => {
    setShowAnswerArea(false)
    setInputText('')
    handleSendAnswer && handleSendAnswer(id, inputText, parentCommentId)
  }

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    resizeTexarea(e.target)
    setInputText(e.target.value)
  }

  const openAnswerBlock = () => setShowAnswerArea(true)
  const closeAnswerBlock = () => setShowAnswerArea(false)

  return (
    <>
      {isShowAnswerArea ? (
        <CommentInputBlock
          inputText={inputText}
          handleChange={handleChange}
          handleSend={sendAnswer}
          closeAnswerBlock={closeAnswerBlock}
        />
      ) : (
        <button className={styles.respondButton} onClick={openAnswerBlock}>
          <Image
            src={imgPath}
            width="16"
            height="16"
            alt="Отправить комментарий"
            unoptimized={true}
          />
          <span className={styles.answerTo}>Ответить</span>
        </button>
      )}
    </>
  )
}

export default CommentSend
